export const AUTH_ERRORS = {
  MULTI_FACTOR_REQUIRED: "auth/multi-factor-auth-required",
  INVALID_VERIFICATION_CODE: "auth/invalid-verification-code",
  INVALID_CREDENTIALS: "auth/invalid-credential",
  EMAIL_ALREADY_IN_USE: "auth/email-already-in-use",
  USER_NOT_FOUND: "auth/user-not-found",
  WRONG_PASSWORD: "auth/wrong-password",
  EMAIL_NOT_VERIFIED: "email-not-verified",
  ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL:
    "auth/account-exists-with-different-credential",
  POPUP_CLOSED: "auth/popup-closed-by-user",
};
